import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api.js';
import  { useEffect, useState, useContext } from "react"
import { useNavigate } from 'react-router-dom';
import { AppContext } from '@utils/AppContext';
import { Pagination } from 'antd';


const AllprojectModal = (props) => {
    const navigate = useNavigate();
    const { module } = props
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(12)
    const [list, setList] = useState([])
    const [total, setTotal] = useState()
    const { setProSidebarValue, member } = useContext(AppContext)

    useEffect(() => {
        listProjectv2()
    }, [pageIndex])

    const listProjectv2 = () => {
        commonApiInvoker(API.listProjectv2({
            pageIndex: pageIndex,
            pageSize: pageSize,
            module: module,
            order: 'desc',
            sortField: 'updatedTime',
            member: member == 'team' ? null : member ? member : globalUser?.id
        })).then(res => {
            setList(res.items)
            setPageSize(res.pageSize)
            setTotal(res.total)
        })
    }

    const onChange = pageNumber => {
        setPageIndex(pageNumber)
    };


    const goProject = (id) => {
        setProSidebarValue(module)
        navigate(`/home/myProject/${id}/detail`)
    }


    return (
        <div className={styles.AllprojectModal}>
            <div className={`${styles.AllprojectModalContent} _beauty_scrollbar`}>
                {/* <div className={styles.AllprojectModalItem} onClick={() => navigate(`/home/myProject/${item.id}/detail`)}>
                    <img src={item.mainImage} alt="" />
                    <p className={styles.itemTitle}>我的收藏</p>
                </div> */}
                {
                    list.map((item) => (
                        <div
                            key={item.id}
                            className={styles.AllprojectModalItem}
                            onClick={() => goProject(item.id)}>
                            <img src={item.mainImage} alt="" />
                            <p className={styles.itemTitle}>{item.projectName}</p>
                            <p className={styles.itemUpdatetime}>{item.updatedTime}</p>
                        </div>
                    ))
                }
            </div>
            <div className={styles.AllprojectModalPagination}>
                <Pagination
                    total={total}
                    onChange={onChange}
                    pageSize={pageSize}
                    current={pageIndex}
                    showSizeChanger={false} />
            </div>

        </div>

    )
}

export default AllprojectModal